// extracted by mini-css-extract-plugin
export default {"code-input":"input-code_code-input__vCtJd","code-inputs":"input-code_code-inputs__VUr9p"};